import Layout from '@undataforum/gatsby-theme-base/src/components/layout';
import 'typeface-roboto';

export default Layout;
